import React from 'react';
import TurnstileWidget from './TurnstileWidget';
import RecaptchaWidget from './RecaptchaWidget';

/** Renders Turnstile or Google reCAPTCHA based on admin security settings. */
export default function CaptchaWidget({
  provider,
  turnstileSiteKey = '',
  recaptchaSiteKey = '',
  recaptchaType = 'v2_checkbox',
  action = 'auth',
  onToken,
  onExpire,
  className,
}) {
  if (provider === 'turnstile' && String(turnstileSiteKey || '').trim()) {
    return (
      <TurnstileWidget
        siteKey={turnstileSiteKey}
        onToken={onToken}
        onExpire={onExpire}
        className={className}
      />
    );
  }

  if (provider === 'recaptcha' && String(recaptchaSiteKey || '').trim()) {
    return (
      <RecaptchaWidget
        siteKey={recaptchaSiteKey}
        type={recaptchaType}
        action={action}
        onToken={onToken}
        onExpire={onExpire}
        className={className}
      />
    );
  }

  return null;
}
